/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Site_Published_SuccessfullyInputs */

const en_site_published_successfully = /** @type {(inputs: Site_Published_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Site published successfully`)
};

const es_site_published_successfully = /** @type {(inputs: Site_Published_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sitio publicado con éxito`)
};

const fr_site_published_successfully = /** @type {(inputs: Site_Published_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Site publié avec succès`)
};

const de_site_published_successfully = /** @type {(inputs: Site_Published_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seite erfolgreich veröffentlicht`)
};

const ja_site_published_successfully = /** @type {(inputs: Site_Published_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サイトが正常に公開されました`)
};

const zh_site_published_successfully = /** @type {(inputs: Site_Published_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`网站发布成功`)
};

const ar_site_published_successfully = /** @type {(inputs: Site_Published_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تم نشر الموقع بنجاح`)
};

const id_site_published_successfully = /** @type {(inputs: Site_Published_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Situs berhasil diterbitkan`)
};

const it_site_published_successfully = /** @type {(inputs: Site_Published_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sito pubblicato con successo`)
};

const ru_site_published_successfully = /** @type {(inputs: Site_Published_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сайт успешно опубликован`)
};

const pt_site_published_successfully = /** @type {(inputs: Site_Published_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Site publicado com sucesso`)
};

const ko_site_published_successfully = /** @type {(inputs: Site_Published_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`사이트가 성공적으로 게시되었습니다`)
};

/**
* | output |
* | --- |
* | "Site published successfully" |
*
* @param {Site_Published_SuccessfullyInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const site_published_successfully = /** @type {((inputs?: Site_Published_SuccessfullyInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Site_Published_SuccessfullyInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_site_published_successfully(inputs)
	if (locale === "es") return es_site_published_successfully(inputs)
	if (locale === "fr") return fr_site_published_successfully(inputs)
	if (locale === "de") return de_site_published_successfully(inputs)
	if (locale === "ja") return ja_site_published_successfully(inputs)
	if (locale === "zh") return zh_site_published_successfully(inputs)
	if (locale === "ar") return ar_site_published_successfully(inputs)
	if (locale === "id") return id_site_published_successfully(inputs)
	if (locale === "it") return it_site_published_successfully(inputs)
	if (locale === "ru") return ru_site_published_successfully(inputs)
	if (locale === "pt") return pt_site_published_successfully(inputs)
	return ko_site_published_successfully(inputs)
});